const PATH = 'fe.components.reports.observation.collapsible_configuration_form';

const messages = {
  completedObservations: {
    key: `${PATH}.completed_observations`,
    defaultValue: 'Completed observations matching your selections'
  },
  fields: {
    time: {
      key: `${PATH}.fields.time`,
      defaultValue: 'Time selection'
    },
    ageLevel: {
      key: `${PATH}.fields.age_level`,
      defaultValue: 'Age Level'
    },
    ageLevelPlaceholder: {
      key: `${PATH}.fields.age_level_placeholder`,
      defaultValue: 'Select an age level'
    },
    hierarchy: {
      key: `${PATH}.fields.hierarchy`,
      defaultValue: 'Hierarchy'
    },
    classVersion: {
      key: `${PATH}.fields.class_version`,
      defaultValue: 'CLASS Version'
    },
    classVersionPlaceholder: {
      key: `${PATH}.fields.class_version_placeholder`,
      defaultValue: 'Select CLASS version'
    },
    classroomDetails: {
      key: `${PATH}.fields.classroom_details`,
      defaultValue: 'Show classroom level detail in the report.'
    },
    classroomDetailsPlaceholder: {
      key: `${PATH}.fields.classroom_details_placeholder`,
      defaultValue:
        'Without this option you will see a summary of the scores of the next node down from your current hierarchy selection.'
    },
    archivedClassrooms: {
      key: `${PATH}.fields.archived_classrooms`,
      defaultValue: 'Include archived classrooms in the report.'
    },
    archivedClassroomsHelper: {
      key: `${PATH}.fields.archived_classrooms_helper`,
      defaultValue:
        'Includes observation data from archived classrooms under your selected nodes, even when those classrooms are not shown in the hierarchy picker above.'
    },
    archivedNodes: {
      key: `${PATH}.fields.archived_nodes`,
      defaultValue: 'Include archived hierarchy nodes in the selector.'
    },
    archivedNodesHelper: {
      key: `${PATH}.fields.archived_nodes_helper`,
      defaultValue:
        'Shows archived sites, schools, and other hierarchy nodes in the picker. Turning this off clears any archived node selections.'
    },
    archivedNodesClassroomsLocked: {
      key: `${PATH}.fields.archived_nodes_classrooms_locked`,
      defaultValue:
        'You can update this option in Configuration 1 for the entire report.'
    }
  }
};

export default messages;
